import { Component, Input, OnDestroy, OnInit, output } from '@angular/core';
import { TreeToRemoveItemForm } from '../../forms/tree-to-remove-item.form';
import { TreeToRemoveAppEntityTreeToRemoveWrite } from '../../../../../../../../openapi';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import {
  ValidationErrorsComponent
} from '../../../../../../../../common/validation-errors/validation-errors.component';
import { NgxMaskDirective } from 'ngx-mask';
import { AlertComponent } from '../../../../../../../../common/alert/alert.component';
import { ObjectTypeEnum } from "../../../../../../../../services/tree-to-remove.common.service";
import { CapitalizeFirstLetterPipe } from "../../../../../../../../pipes/capitalize-first-letter.pipe";
import { TrunkCircumferenceCrudComponent } from "../trunk-circumference-crud/trunk-circumference-crud.component";

@Component({
  selector: 'app-tree-to-remove-item-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    ValidationErrorsComponent,
    NgxMaskDirective,
    AlertComponent,
    CapitalizeFirstLetterPipe,
    TrunkCircumferenceCrudComponent
  ],
  templateUrl: './tree-to-remove-item-form.component.html'
})
export class TreeToRemoveItemFormComponent implements OnDestroy, OnInit {

  public submit = output<TreeToRemoveAppEntityTreeToRemoveWrite>();

  public cancel = output<void>();

  @Input()
  public form: TreeToRemoveItemForm | undefined;

  @Input()
  public edit = false;

  @Input()
  public treeItemFormType: ObjectTypeEnum | null = null;

  public onSubmit(): void {
    if (this.form?.valid && !this.form.removalReason.unchecked) {
      this.submit.emit(this.form.values);
    } else {
      this.form?.markAllAsTouched();
    }
  }

  public onCancel(): void {
    this.cancel.emit();
    this.form?.reset();
  }

  public ngOnInit(): void {
    this.form?.objectType.setValue(this.treeItemFormType);
  }

  public ngOnDestroy(): void {
    this.form?.reset();
    this.form?.removeControl('trunkCircumference130');
    this.form?.removeControl('trunkCircumference130Form');
  }
}
